var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireLtr = function SvgFireLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M71.807 37.88c-2.397-5.92-5.72-9.247-8.025-11.145 1.145 6.208-2.83 14.934-3.493 11.834C58.575 30.55 53.994 15.869 40.742 9c1.16 33.391-20.668 29.628-18.604 56.126.868 11.152 7.335 20.736 16.864 24.634-4.147-2.952-7.058-7.795-7.058-12.838 0-4.117.249-9.198 2.804-14.105.365-.7 3.177-5.135 4.457-6.19-.636 3.448 1.572 8.295 1.94 6.573.951-4.453 3.496-12.607 10.856-16.422-.644 18.545 11.478 16.455 10.332 31.172-.441 5.66-3.48 10.59-8.04 13.05 12.101-2.686 21.77-13.769 22.561-27.723.911-16.079-2.65-19.477-5.047-25.397",
    clipRule: "evenodd"
  })));
};
export default SvgFireLtr;